import { Kind, print } from "graphql";
export function getOperationName(operation) {
    if (!operation.name) {
        throw new Error(`Cannot get an operation name from an anonymous operation.`);
    }
    return operation.name.value;
}
export function getQueryName(document) {
    const queryDefinition = document.definitions.find((def)=>def.kind === Kind.OPERATION_DEFINITION && def.operation === 'query');
    if (!queryDefinition) {
        throw new Error(`There is no query defined on this document: ${print(document)}`);
    }
    return getOperationName(queryDefinition);
}
function createQueryOperationNode(name, topLevelVariableDefinitions, topLevelFields) {
    return {
        kind: Kind.OPERATION_DEFINITION,
        operation: 'query',
        name: {
            kind: Kind.NAME,
            value: name
        },
        variableDefinitions: topLevelVariableDefinitions,
        directives: [],
        selectionSet: {
            kind: Kind.SELECTION_SET,
            selections: topLevelFields
        }
    };
}
export function createQueryDocument(queryName, queryVariablesDefinitions, queryFields, fragmentDefinitions) {
    const queryOperationNode = createQueryOperationNode(queryName, queryVariablesDefinitions, queryFields);
    return {
        kind: Kind.DOCUMENT,
        definitions: [
            queryOperationNode,
            ...fragmentDefinitions
        ]
    };
}

//# sourceMappingURL=query.js.map